import { ActionPayload } from '../../../types/common/action';
import { GoogleMapsStatus } from '../../../types/map/maps';

// constants
export const SET_GOOGLE_MAPS_STATUS = 'SET_GOOGLE_MAPS_STATUS';

// types
export type SetGoogleMapsStatusAction = ActionPayload<GoogleMapsStatus> & {
    type: typeof SET_GOOGLE_MAPS_STATUS
};

export const setGoogleMapsStatus = (payload:GoogleMapsStatus) : SetGoogleMapsStatusAction => ({
    type: SET_GOOGLE_MAPS_STATUS,
    payload
});
